import { render, staticRenderFns } from "./PassWordReSet.vue?vue&type=template&id=590674f8&"
import script from "./PassWordReSet.vue?vue&type=script&lang=js&"
export * from "./PassWordReSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports